import React from "react";
import Heading from "../ResourceTileComponents/Heading";
import Pagination from "~/common/Pagination";
import Resource from "../Resource";
import CardGrid from "../ResourceTileComponents/CardGrid";

interface FoodServiceResourcesTypeLandingProps {
  displayHeader: string;
  resources: Resource[];
  footerText: string;
  currentPage: number;
  pageSize: number;
  totalRecords: number;
  resourceTypeSlug: string;
  hasRecentPosts?: boolean;
}

const FoodServiceResourcesTypeLanding = ({
  displayHeader,
  resources,
  footerText,
  currentPage,
  pageSize,
  totalRecords,
  resourceTypeSlug,
  hasRecentPosts = true,
}: FoodServiceResourcesTypeLandingProps) => {
  const showBrowseSection = resources.length > 5;

  const adjustedTotalRecords = showBrowseSection
    ? totalRecords - 5
    : totalRecords;

  // Determine the starting index and slice count for the resources displayed in CardGrid

  // `startSliceIndex` is the index at which to start slicing the resources array.
  // For the first page (i.e., `currentPage === 1`), we start at index 5 to skip the first 5 items which are shown in the recent posts section.
  // For subsequent pages, we start from index 0 to show all available resources.

  // `sliceCount` defines how many items to include in the slice.
  // On the first page, `sliceCount` is set to 5 (the number of resources to show in the recent posts section).
  // For other pages, we use `sliceCount` of 36 to display up to 36 resources per page, assuming there are more resources to show.
  const startSliceIndex = currentPage === 1 ? 5 : 0;
  const sliceCount = currentPage === 1 ? undefined : 36;

  return (
    <div
      className="pt-4 px-4 xs:px-0 xs:pt-0 lt:pl-[30px] lt:pt-[30px]"
      data-module="foodServiceResourcesTypeLanding"
    >
      {currentPage === 1 && hasRecentPosts && (
        <>
          <Heading
            className="feature-heading border-0 mb-0 pb-2 md:border-b md:border-gray-200 md:border-solid"
            headingType="sectionHeading"
          >
            Recent {displayHeader}
          </Heading>
          <CardGrid
            resources={resources}
            startSliceIndex={0}
            sliceCount={5}
            hasRecentPosts={hasRecentPosts}
          />
        </>
      )}
      {showBrowseSection && (
        <>
          <Heading
            className="feature-heading border-0 mb-0 pb-2 md:border-b md:border-gray-200 md:border-solid"
            headingType="sectionHeading"
          >
            Browse {displayHeader}
          </Heading>
          <CardGrid
            resources={resources}
            startSliceIndex={startSliceIndex}
            sliceCount={sliceCount}
            hasRecentPosts={false}
          />
        </>
      )}
      {showBrowseSection && (
        <div className="p-3 text-center">
          <Pagination
            total={adjustedTotalRecords}
            pageSize={pageSize}
            currentPage={currentPage}
            createHREF={(pageNumber) =>
              `/food-service-resources/type/${resourceTypeSlug}/page/${pageNumber}/`
            }
          />
        </div>
      )}
      <div className="fsr-content-wrap">
        <p className="small">{footerText}</p>
      </div>
    </div>
  );
};

export default FoodServiceResourcesTypeLanding;
